export default __webpack_public_path__ + "static/media/goongle.24d6cd24.png";